module.exports = __webpack_public_path__ + "img/19_r.14987c42.jpg";